
import React, { useState, useEffect } from 'react';
import styles from './stockCard.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { addToScheduleThunk } from '../../../../redux/ScheduleSlice';
import { addToCartThunk } from '../../../../redux/cartSlice';
import { setLoginpopup } from '../../../../redux/customerSlice';
import { toast } from 'react-toastify';
import api from '../../../../utils/api';


const StockCard = ({ inventory, quantityTable, productOverview, id, isLoggedin, status, additionalResources, gst }) => {

  const { loading } = useSelector((state) => state.cart);
  const { addScheduleloading } = useSelector((state) => state.schedule);
  const dispatch = useDispatch();

  const spq = inventory?.minimumMultiplier || 
              (Array.isArray(additionalResources?.Standard_Packaging_Quantity) ? additionalResources.Standard_Packaging_Quantity[0] : additionalResources?.Standard_Packaging_Quantity) || 
              1;
  const numSpq = Number(spq) || 1;

  const [quantityError, setQuantityError] = useState('');
  const [quantity, setQuantity] = useState(numSpq);
  const [outofStockloading, setoutOfstockloading] = useState(false);

  useEffect(() => {
    if (numSpq) {
      setQuantity(numSpq);
      setQuantityError('');
    }
  }, [numSpq, id]);

  const validateQuantity = (value) => {
    if (value === '' || value === null || value === undefined) {
      setQuantityError('');
      return false;
    }

    const numValue = Number(value);
    const minMultiplier = numSpq;
    const availQty = inventory?.qtyAvailable || 0;

    if (inventory?.qtyAvailable <= 0 || status === 'OUT OF STOCK') {
      setQuantityError('Out of stock');
      return false;
    }

    if (isNaN(numValue)) {
      setQuantityError('Please enter a valid number');
      return false;
    }

    if (numValue <= 0) {
      setQuantityError('Quantity must be greater than 0');
      return false;
    }

    if (numValue < minMultiplier) {
      setQuantityError(`Quantity must be at least ${minMultiplier}`);
      return false;
    }

    if (numValue > availQty) {
      setQuantityError(`Only ${availQty} items available in stock`);
      return false;
    }

    if (numValue % minMultiplier !== 0) {
      setQuantityError(`Quantity must be in multiples of ${minMultiplier}`);
      return false;
    }

    setQuantityError('');
    return true;
  };

  const handleQuantityChange = (e) => {
    const value = e.target.value;
    setQuantity(value);
    validateQuantity(value);
  };

  const groupedData = quantityTable?.reduce((groups, item) => {
    const { packaging } = item;
    if (!groups[packaging]) {
      groups[packaging] = [];
    }
    groups[packaging].push(item);
    return groups;
  }, {});

  const getBreakQtyDetails = (quantityTable, quantity) => {
    if (Array.isArray(quantityTable) && quantityTable.length > 0) {
      const sortedTable = [...quantityTable].sort((a, b) => (a?.breakQty || 0) - (b?.breakQty || 0));
      return sortedTable.find((entry) => quantity <= entry?.breakQty) || sortedTable[sortedTable.length - 1] || { breakQty: 1, unitPrice: 0 };
    } else {
      return {
        breakQty: 1, unitPrice: 0
      };
    }
  };

  const { unitPrice } = getBreakQtyDetails(
    quantityTable,
    quantity
  );
  const hasUnitPrice = Number(unitPrice) > 0;
  const isInStock = inventory?.qtyAvailable > 0 && status !== "OUT OF STOCK";

  const isQuantityValid = () => {
    const numValue = Number(quantity);
    const minMultiplier = numSpq;
    const availQty = inventory?.qtyAvailable || 0;

    if (inventory?.qtyAvailable <= 0 || status === 'OUT OF STOCK') {
      return false;
    }

    return (
      !isNaN(numValue) &&
      numValue > 0 &&
      numValue >= minMultiplier &&
      numValue <= availQty &&
      numValue % minMultiplier === 0
    );
  };

  const addtoCart = async (from, productId) => {

    if (!isLoggedin) {
      return dispatch(setLoginpopup(true))
    }
    const products = [{
      productId: id,
      totalQty: parseInt(quantity, 10),
      quantity: parseInt(quantity, 10),
    }];
    if (from == 'cart') {
      const status = await dispatch(addToCartThunk(products))
      if (status?.payload === 200) {
      }
    }
    else {
      const status = await dispatch(addToScheduleThunk(products))

      if (status?.payload === 200) {
      }
    }
  };

  const checkAvailability = async () => {

    if (!isLoggedin) {
      toast.error("Please login to check availability")
      return dispatch(setLoginpopup(true))
    }


    if (!quantity || quantity <= 0) {
      toast.error("Please enter the quantity")
      return null;
    }

    try {
      setoutOfstockloading(true)
      const { status } = await api.sendWizardEnquiry({
        partList: [
          {
            expectedPrice: "",
            manufacturer: productOverview?.manufacturer[0]?.name || "",
            masterPrice: "",
            productNumber: productOverview?.productNumber[0] || "",
            quantity,
            requiredDate: new Date(),
            gst: gst || 0
          }
        ]
      })

      if (status === 200) {
        toast.success("Enquiry submitted successfully")
      }
    } catch (err) {
      console.log(err)
      toast.error("Something went wrong")
    } finally {
      setoutOfstockloading(false);
    }
  };


  return (
    <div className={styles.card}>
      <div className={styles.stockSection}>
        <div className={styles.displayCol}>
          {(inventory?.qtyAvailable > 0 && status != "OUT OF STOCK") ?
            <span className={styles.stockQuantity}>{inventory?.qtyAvailable} In Stock</span>
            :
            <span className={styles.stockQuantity} style={{ color: 'red' }}>Out of stock</span>
          }
          <span className={styles.shipText}> {inventory?.qtyAvailable > 0 ? "Can ship immediately" : "Short lead time: " + (inventory?.shortLeadTime || "")} </span>
        </div>
      </div>

      <div className={styles.productInputSection}>
        <label className={styles.label}>
          Product Quantity
        </label>
        <input
          type="number"
          className={styles.quantityInput}
          placeholder="Enter"
          value={quantity || ''}
          onChange={handleQuantityChange}
          min={numSpq}
          step={numSpq}
        />
        {quantityError && <div className={styles.errorText}>{quantityError}</div>}
        <div className={styles.displayFlex}>
          <div className={styles.spqText}>SPQ {numSpq}</div>
          <div className={styles.minimumText}>Minimum {numSpq}</div>
        </div>
      </div>

      {hasUnitPrice && quantity > 0 && isQuantityValid() && (
        <div>
          <table className={styles.pricingTable}>
            <thead>
              <tr>
                <th>Quantity</th>
                <th>Unit Price</th>
                <th>Total Price</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ background: 'white' }}>{quantity}</td>
                <td style={{ background: 'white' }}>₹{unitPrice}</td>
                <td style={{ background: 'white' }}>₹{(quantity * unitPrice)?.toFixed(2)}</td>
              </tr>
              <tr style={{ background: 'white' }}>
                <td style={{ background: 'white' }}></td>
                <td style={{ background: 'white' }}></td>
                <td style={{ fontWeight: '800', fontSize: 16, background: 'white' }}>₹{(quantity * unitPrice)?.toFixed(2)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}

      <div className={styles.actionButtons}>
        {isInStock && hasUnitPrice ?
          <>
            <button
              className={styles.addToCartButton}
              disabled={!isQuantityValid()}
              style={{ background: !isQuantityValid() ? '#a284e6' : '#512DA8' }}
              onClick={() => addtoCart('cart', id)}
            >
              {loading ? 'please wait...' : 'Add to cart'}
            </button>
            <button
              className={styles.addToScheduleButton}
              onClick={() => addtoCart('schedule', id)}
              disabled={!isQuantityValid()}
              style={{ color: !isQuantityValid() ? '#a284e6' : '#512DA8' }}
            >
              {addScheduleloading ? 'please wait...' : 'Add to schedule'}
            </button>
          </>
          :
          <>
            <button
              className={styles.addToCartButton}
              disabled={outofStockloading}
              style={{ background: '#512DA8' }}
              onClick={checkAvailability}
            >
              {outofStockloading ? 'please wait...' : isInStock ? 'Request a quote' : 'Check availability'}
            </button>

          </>
        }
      </div>

      {Object.entries(groupedData || {}).map(([packagingType, items]) => {
        const pricedItems = items.filter((item) => Number(item?.unitPrice) > 0);

        if (!pricedItems.length) return null;

        return <div key={packagingType}>
          <table className={styles.pricingTable}>
            <thead>
              <tr>
                <th>Quantity</th>
                <th>Unit Price</th>
                <th>Total Price</th>
              </tr>
            </thead>
            <tbody>
              {pricedItems.map((item) => (
                <tr key={item._id}>
                  <td>{item?.breakQty}</td>
                  <td>₹{item?.unitPrice}</td>
                  <td>₹{(item?.breakQty * item?.unitPrice).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>;
      })}
    </div>
  );
};

export default StockCard;

















